<script>
import { Line } from 'vue-chartjs';
 
export default {
  extends: Line,
  mounted () {
    this.renderChart({
      labels: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Junho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
      datasets: [
        {
          label: 'Matriculas',
          backgroundColor: '#00bcd4',
          borderColor: '#00bcd4',
          // data: [40, 20, 12, 39, 10, 40, 39, 80, 40, 20, 12, 11],
          data: [400, 200, 120, 390, 150, 400, 390, 800, 400, 200, 120, 110],
          pointRadius: 5,
          pointHoverRadius: 15,
          fill: false
        }
      ]
    }, {
      options: { 
        responsive: true, 
      },
      legend: {
        display: false
      },
    });
  }
}
</script>

<style>

</style>
